import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useAuth } from "@/hooks/useAuth";
import { MenuItem } from "./constants/menus";
import { useTranslation } from "react-i18next";
import { useAtom } from "jotai";
import { companyAtom } from "@/store/company";

interface SidebarProps {
  className?: string;
  menu: MenuItem[];
  close?: () => void;
  hasTopMargin?: boolean;
}

export default function Sidebar({
  className,
  menu,
  close,
  hasTopMargin = true,
}: SidebarProps) {
  const location = useLocation();
  const { user } = useAuth();
  const { t } = useTranslation();
  const [company] = useAtom(companyAtom);

  // Combine navigation items based on user role
  const navigation = [...menu];
  const isMobile = !!close;

  return (
    <aside
      className={cn(
        "flex flex-col w-full lg:w-[98px] lg:fixed lg:inset-y-0 bg-[#e5e5e5] border-none h-screen overflow-hidden",
        className,
      )}
    >
      {/* {!isMobile && (
        <div className="h-24 w-full absolute top-0 left-0 border-b z-10 bg-background" />
      )} */}
      <nav
        className={cn(
          "flex-1 overflow-y-auto px-2 py-4 space-y-1",
          !isMobile ? (hasTopMargin ? "mt-24" : "mt-0") : "pt-4",
        )}
      >
        {navigation.map((item) => {
          // console.log("location.pathname", location.pathname);
          // console.log("item.href", item.href);

          const isActive =
            (location.pathname === "/dasboard" && item.href === "/") ||
            location.pathname === item.href ||
            (item.name === "menu.measure" &&
              location.pathname.includes("facilities")) ||
            location.pathname === item.href ||
            (item.name === "menu.measure" &&
              location.pathname.includes("vehicles"));
          const Icon = item.icon;
          const hasRole =
            (user?.rol && item.roles?.includes(user.rol)) || !item.roles;

          return (
            <div key={item.name}>
              {hasRole ? (
                <>
                  {item.href === "" ? (
                    <div
                      key={item.name}
                      className="w-full h-8 py-8 text-xs font-regular text-center text-black"
                    >
                      <span className="py-1 px-4 bg-lime-200 rounded-full">
                        {t(item.name)}
                      </span>
                    </div>
                  ) : (
                    <Link
                      onClick={() => {
                        console.log("close in link");
                        close?.();
                      }}
                      to={item.href}
                      className="flex flex-col items-center gap-1 "
                      hidden={item.canHide && company?.id === null}
                    >
                      <div
                        role="button"
                        key={item.name}
                        className={cn(
                          "w-[42px] h-[42px] rounded-md flex items-center justify-center hover:bg-[#f5f5f5]",
                          isActive ? "bg-[#A0F800]" : "",
                        )}
                      >
                        <Icon />
                      </div>
                      <span
                        className={cn(
                          "text-[10px] text-center break-all",
                          isActive ? "text-black" : "text-primary-foreground",
                        )}
                      >
                        {t(item.name)}
                      </span>
                    </Link>
                  )}
                </>
              ) : null}
            </div>
          );
        })}
      </nav>
    </aside>
  );
}
